import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Accounts = function Accounts(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.5 23C11.8125 23 8 19.1875 8 14.5C8 9.8125 11.8125 6 16.5 6C21.1875 6 25 9.8125 25 14.5C25 19.1875 21.1875 23 16.5 23ZM16.5 8C12.9125 8 10 10.9125 10 14.5C10 18.0875 12.9125 21 16.5 21C20.0875 21 23 18.0875 23 14.5C23 10.9125 20.0875 8 16.5 8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 18C32.6875 18 30 15.3125 30 12C30 8.6875 32.6875 6 36 6C39.3125 6 42 8.6875 42 12C42 15.3125 39.3125 18 36 18ZM36 8C33.8 8 32 9.8 32 12C32 14.2 33.8 16 36 16C38.2 16 40 14.2 40 12C40 9.8 38.2 8 36 8Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 43H0V41.5C0 32.4 7.4 25 16.5 25C25.6 25 33 32.4 33 41.5V43ZM2.0125 41H31C30.7375 33.2375 24.3375 27 16.5125 27C8.6875 27 2.275 33.2375 2.0125 41Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M48 34H29.4625V32H46C46 26.4875 41.5125 22 36 22C31.6125 22 27.675 24.9375 26.4125 29.1375L24.5 28.5625C26 23.525 30.7375 20 36 20C42.6125 20 48 25.3875 48 32V34Z",
      fill: secondaryColor
    })]
  });
};
export default Accounts;